import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface SewerOrSepticProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const SewerOrSeptic: React.FC<SewerOrSepticProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [sewerOrSeptic, set_sewerOrSeptic] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['Sewer or Septic']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'Sewer or Septic': [b.values?.['Major Systems']?.['Sewer or Septic']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Sewer Or Septic';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(sewerOrSeptic)}
                />
            ) : (
                <MoneyBox
                    id={'sewerOrSeptic'}
                    allowNegative={false}
                    value={sewerOrSeptic}
                    onChange={(value) => set_sewerOrSeptic(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
